import Card from './card';
import './card.scss';

export default Card;
